// RiskManagementContext.tsx
import React, { createContext, useContext, useState, PropsWithChildren } from 'react';
import { RiskManagementplanList } from '../../pages/RiskManagement/modal';

// Define the interface for context values
interface RiskManagementContextType {
    tabValue: number | null; 
    setTabValue: React.Dispatch<React.SetStateAction<number | null>>;
    selectedRiskManagement: RiskManagementplanList | null; 
    setSelectedRiskManagement: React.Dispatch<React.SetStateAction<RiskManagementplanList | null>>;
    planDetails: any; 
    setPlanDetails: React.Dispatch<React.SetStateAction<any>>;
    selectedAppendix:any, 
    setSelectedAppendix: React.Dispatch<React.SetStateAction<any>>;
    appendixDetails:any, 
    setAppendixDetails: React.Dispatch<React.SetStateAction<any>>;
}

// Create context with initial values
const RiskManagementContext = createContext<RiskManagementContextType | undefined>(undefined);

// Create a provider component to wrap your app
export const RiskManagementProvider = ({ children }: PropsWithChildren<{}>) => {
    const [tabValue, setTabValue] = useState<number | null>(null);
    const [selectedRiskManagement, setSelectedRiskManagement] = useState<RiskManagementplanList | null>(null);
    const [planDetails, setPlanDetails] = useState<any>({});
    const [selectedAppendix, setSelectedAppendix] = useState<any>([]);
    const [appendixDetails, setAppendixDetails] = useState<any>([]);

    return (
        <RiskManagementContext.Provider value={{
            tabValue, setTabValue,
            selectedRiskManagement, setSelectedRiskManagement,
            planDetails, setPlanDetails,
            selectedAppendix, setSelectedAppendix,
            appendixDetails, setAppendixDetails
        }}>
            {children}
        </RiskManagementContext.Provider>
    );
};

// Create a custom hook for using RiskManagementContext
export const useRiskManagementContext = () => {
    const context = useContext(RiskManagementContext);
    if (!context) {
        throw new Error('useRiskManagementContext must be used within a RiskManagementProvider');
    }
    return context;
};

export default RiskManagementContext;
